<template>
    <div >
        <div class="modal_flex" >
            <div class="item_box" style="font-size: 18px;font-weight: bold;">
                <div class="title_box">签约管理</div>
            </div>
            <div class="item_box" style="color: #277dd3;">签约审核状态：{{formItem.status_name}}</div>
        </div>
        <div class="modal_flex" >
            <div class="item_box">
                <div class="title_box"><span class="icon iconfont icon-bixuan"></span>客户经理：</div>
                <Input v-model="formItem.manager"  disabled style="width: 250px;"></Input>
            </div>
            <div class="item_box">
                <div class="title_box"><span class="icon iconfont icon-bixuan"></span>部门：</div>
                <Input v-model="formItem.department" disabled style="width: 250px;"></Input>
            </div>
        </div>
        <div class="modal_flex">
            <div class="item_box">
                <div class="title_box"><span class="icon iconfont icon-bixuan"></span>客户姓名：</div>
                <Input v-model="formItem.client_name" disabled style="width: 250px;"></Input>
            </div>
            <div class="item_box">
                <div class="title_box"><span class="icon iconfont icon-bixuan"></span>客户手机号：</div>
                <Input v-model="formItem.phone" disabled style="width: 250px;"></Input>
            </div>
        </div>
        <div class="modal_flex">
            <div class="item_box">
                <div class="title_box"><span class="icon iconfont icon-bixuan"></span>合同号：</div>
                <Input v-model="formItem.contract_number" disabled style="width: 250px;"></Input>
            </div>
            <div class="item_box">
                <div class="title_box"><span class="icon iconfont icon-bixuan"></span>费率：</div>
                <Input v-model="formItem.rate" disabled style="width: 250px;">
                    <span slot="append">%</span>
                </Input>
            </div>

        </div>
        <div class="modal_flex">
            <div class="item_box">
                <div class="title_box"><span class="icon iconfont icon-bixuan"></span>诚意金：</div>
                <Input v-model="formItem.sincerity_money" disabled style="width: 250px;">
                    <span slot="append">元</span>
                </Input>
            </div>
            <!--div class="item_box">
                <Button class="btn" @click="uploadModal = true" type="primary" v-if="formItem.sincerity_deal_status == 0">上传凭证退款</Button>
                <Button class="btn" @click="applySincerityIncome" type="primary" v-if="formItem.sincerity_deal_status == 0">申请转创收</Button>
                <Button class="btn" style="margin-left: 40px"  type="default" v-if="formItem.sincerity_deal_status == -1">已申请退款</Button>
                <Button class="btn" style="margin-left: 40px"  type="default" v-if="formItem.sincerity_deal_status == 1">已确认退款</Button>
                <Button class="btn" style="margin-left: 40px"  type="default" v-if="formItem.sincerity_deal_status == -2">已申请转为创收</Button>
                <Button class="btn" style="margin-left: 40px"  type="default" v-if="formItem.sincerity_deal_status == 2">已确认转为创收</Button>
                <span>诚意金状态：{{formItem.sincerity_status_name}}</span>
            </div-->
        </div>
        <div class="modal_flex" v-if="formItem.sincerity_id != 0">
            <div class="item_box">
                <div class="title_box"><span class="icon iconfont icon-bixuan"></span>诚意金收款方式：</div>
                <Select v-model="formItem.sincerity_type"  disabled style="width:250px">
                    <Option v-for="item in sincerity_type_list" :value="item.value" :key="item.value">{{
                        item.label }}
                    </Option>
                </Select>
            </div>
			<div class="item_box">
			    <div class="title_box"><span class="icon iconfont icon-bixuan"></span>诚意金：</div>
			    <Input v-model="formItem.sincerity_money" disabled style="width: 250px;">
			    </Input>
			</div>
        </div>
        <div class="modal_flex">
            <div style="width: 130px; text-align: right;">备注：</div>
            <Input v-model="formItem.remark" disabled style="width: 700px;" type="textarea" :rows="4"/>
        </div>
        <div class="modal_flex">
            <div style="width: 130px; text-align: right;">添加合同资料：</div>
            <MyUpload  ref="upload"></MyUpload>
        </div>
        <Modal
                v-model="uploadModal"
                title="上传凭证退款"
                @on-cancel="() => {uploadModal = false}"
                @on-ok="fileOk">
            <addFile ref="addFile" :needFileName="0" :fileFormat="['jpg','jpeg','png','gif']"></addFile>
        </Modal>
    </div>
</template>

<script>
    import addFile from '../tool/addFile.vue';
    import MyUpload from '../tool/Upload.vue'
    import {
        getContract,applySincerityRefund,applySincerityIncome
    } from '@/api/task'
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "ContractDetail",
        components: {MyUpload, addFile},
        props: ['contractId'],
        mounted() {
            this.loadData();
        },
        computed: {
            ...mapGetters(['token']),
        },
        watch: {
            contractId() {
                this.loadData();
            }
        },
        data() {
            return {
                uploadModal: false,
                formItem: {
                    manager: '',
                    department: '',
                    client_name: '',
                    phone: '',
                    contract_number: '',
                    rate: '',
                    sincerity_money: '',
                    sincerity_type: '',
                    remark: '',
                    status_name: '',
                    sincerity_status_name: '',
                },
                sincerity_type_list: [{
                    value: 1,
                    label: '支付宝',
                },{
                    value: 2,
                    label: '微信支付',
                },{
                    value: 3,
                    label: '现金支付',
                },{
                    value: 4,
                    label: '银行卡支付',
                },],
            }
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            async loadData() {
                let that = this;
                if (that.contractId != 0) {
                    let res = await getContract(that, {token: that.token, id: that.contractId});
                    if (res.code = 1) {
                        that.formItem = res.data.item;
                        that.$refs['upload'].uploadList = res.data.item.ext_info.imgList;
                        that.modal = true;
                    }
                }
            },
            fileOk() {
                var that = this;
                let fileUrl = that.$refs['addFile'].fileUrl;
                this.throttle(async function () {
                    let res = await applySincerityRefund(that, {token: that.token, id: that.formItem.sincerity_id, file: fileUrl});
                    if (res.code = 1) {
                        that.loadData();
                        that.uploadModal = false;
                    }
                }, 500)
            },
            applySincerityIncome() {
                let that = this;
                this.$Modal.confirm({
                    title: '确认申请转为创收吗？',
                    onOk: async () => {
                        let res = await applySincerityIncome(that, {token: that.token, id: that.formItem.sincerity_id});
                        if (res.code == 1) {
                            that.$Message.success(res.msg);
                            that.loadData();
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .icon-bixuan {
        color: red;
    }

    .title_css {
        width: 86px;
        text-align: right;
        margin-right: 10px;
    }

    .list_flex {
        display: flex;
        align-items: center;
        margin: 10px 0;
    }

    .modal_flex {
        display: flex;
        align-items: center;
        margin: 10px 0;

        .item_box {
            width: 50%;
            display: flex;
            align-items: center;

            .btn {
                margin: 0 10px;
            }

            .title_box {
                width: 130px;
                text-align: right;
            }
        }

        .icon-bixuan {
            color: #FE485B;
        }
    }
</style>
